export var UPDATE_NR_PRODUCT_LIST = "UPDATE_NR_PRODUCT_LIST";
export var UPDATE_FINAL_FILTERSTATE = "UPDATE_FINAL_FILTERSTATE";
